export interface GzMultiSelectItem {
  label: string;
  value: string | number;
  disabled?: boolean;
}

export enum MultiSelectEvents {
  CHANGE = 'change',
}
